<template>
  <div class="question-block text-center py-5">
    <div class="question-block__icon">
      <fa-icon
        icon="question-circle"
        size="5x"
      />
    </div>
    <div class="text-thin h5">
      <strong> Del 1 al 10, ¿Qué tan fácil </strong> crees que les fue a los egresados
      de  {{ careerName }}, conseguir un empleo?
    </div>
    <div
      v-if="!showResponse"
      class="d-flex justify-content-center align-items-center"
    >
      <div class="mr-2">
        <input
          v-model="response"
          type="range"
          max="10"
          min="1"
          value="1"
        >
      </div>
      <div class="d-flex align-items-center">
        <input
          v-model="response"
          type="number"
          pattern="\d*"
          class="form-control question-block__response"
          value="1"
        >
      </div>
    </div>
    <div
      v-if="showResponse"
      class="d-flex justify-content-center align-items-center"
    >
      <p> {{ appResponse }}</p>
    </div>
    <base-button
      v-if="!showResponse"
      @click="onResponse"
    >
      Responder
    </base-button>
    <base-button
      v-if="showResponse"
      @click="onSubmit"
    >
      Conocer más
    </base-button>
  </div>
</template>

<script>
export default {
    name: 'SalaryQuestion',
    props: {
        careerName: {
            type: String,
            required: true,
        },
        careerAverage: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            showResponse: false,
            appResponse: 'Estamos recopilando datos para entregarte información detallada sobre esta carrera',
            response: 0,
        };
    },
    methods: {
        onSubmit() {
            const jsonResponse = {
                guess: parseFloat(this.response),
                real: this.careerAverage,
            };

            this.$emit('answered', 'employability', jsonResponse);
        },
        onResponse() {
            const average = this.careerAverage;
            this.showResponse = true;
            const lowerBound = average - 1;
            const upperBound = average + 1;
            if (this.response < lowerBound) {
                this.appResponse = 'Según información de egresados, en promedio, '.concat(
                    'esta carrera se encuentra en el nivel de empleabilidad ',
                    average.toString(), '. Más de lo que pensabas!',
                );
            } else if (this.response > upperBound) {
                this.appResponse = 'Según información de egresados, en promedio, '.concat(
                    'esta carrera se encuentra en el nivel de empleabilidad ',
                    average.toString(), '. Menos de lo que pensabas!',
                );
            } else {
                this.appResponse = 'Según información de egresados, en promedio, '.concat(
                    'esta carrera se encuentra en el nivel de empleabilidad ',
                    average.toString(), '. Muy bien! tu respuesta ha sido muy cercana a la cifra oficial.',
                );
            }
        },
    },
};
</script>
<style lang="scss">
@import "../../scss/style";
.question-block{
    &__icon{
        color: $primary;
    }
    & > div{
        margin-bottom: 1rem;
    }
    &__response{
        max-width: 80px;
        text-align: right;

        &[type=number]::-webkit-inner-spin-button,
        &[type=number]::-webkit-outer-spin-button
        {
            display: none;
        }
    }
}
</style>
